import React from "react";
import { Link } from "react-router-dom";

const LOGO_SRC = `${process.env.PUBLIC_URL}/AlphaSniperTradingLogo_sans_ecriture_sharpened-removebg-preview.png?v=20260501c`;
const WORDMARK_SRC = `${process.env.PUBLIC_URL}/AlphaSniperTrading-Black-RBG.png?v=20260501h`;

// flex-nowrap + no w-full on wordmark keeps Logo | Wordmark | Logo on one line.
const LOGO_DEFAULT =
  "h-[13.5rem] w-auto shrink-0 object-contain drop-shadow-[0_8px_20px_rgba(0,0,0,0.4)] sm:h-60 md:h-[16.5rem] lg:h-72";
const WORDMARK_DEFAULT =
  "h-auto w-auto max-h-[11.25rem] shrink object-contain brightness-110 contrast-110 drop-shadow-[0_8px_20px_rgba(0,0,0,0.4)] max-w-[375px] sm:max-h-[13.125rem] sm:max-w-[488px] md:max-h-60 md:max-w-[563px] lg:max-h-[16.875rem] lg:max-w-[638px] -mx-2 md:-mx-3 lg:-mx-4";

/** Smaller than default so logo | wordmark | logo fits typical viewports without clipping. */
const LOGO_COMPACT =
  "h-24 w-auto shrink-0 object-contain drop-shadow-[0_4px_12px_rgba(0,0,0,0.35)] sm:h-28 md:h-32 lg:h-36";
const WORDMARK_COMPACT =
  "h-auto w-auto max-h-[5.25rem] shrink-0 object-contain brightness-110 contrast-110 drop-shadow-[0_4px_12px_rgba(0,0,0,0.35)] max-w-[200px] sm:max-h-28 sm:max-w-[260px] md:max-h-32 md:max-w-[300px] lg:max-h-36 lg:max-w-[340px] -mx-0.5 sm:-mx-1";

/**
 * Centered brand row: logo — wordmark — logo (same assets as home / auth).
 * @param {{ variant?: "default" | "compact"; className?: string; overflow?: "auto" | "visible" }} props
 */
export default function LegalPagesBrandHeader({
  variant = "default",
  className = "",
  overflow = "auto",
}) {
  const compact = variant === "compact";
  const logoClass = compact ? LOGO_COMPACT : LOGO_DEFAULT;
  const wordmarkClass = compact ? WORDMARK_COMPACT : WORDMARK_DEFAULT;
  const wrap = compact ? "mb-3" : "mb-4";
  const overflowClass =
    overflow === "visible"
      ? "overflow-x-visible"
      : "overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden";

  return (
    <div
      className={`${wrap} flex flex-nowrap items-center justify-center gap-0 py-0 ${overflowClass} ${className}`.trim()}
    >
      <Link to="/" className="shrink-0" aria-label="Home">
        <img src={LOGO_SRC} alt="" className={logoClass} decoding="async" />
      </Link>
      <Link to="/" className="shrink-0" aria-label="Home">
        <img
          src={WORDMARK_SRC}
          alt="AlphaSniper Trading"
          className={wordmarkClass}
          decoding="async"
        />
      </Link>
      <Link to="/" className="shrink-0" aria-label="Home">
        <img src={LOGO_SRC} alt="" className={logoClass} decoding="async" />
      </Link>
    </div>
  );
}
